__turbopack_context__.v({
  "appear": "NewsletterForm-module___4_Mja__appear",
  "blok-big-title": "NewsletterForm-module___4_Mja__blok-big-title",
  "blok-subtitle": "NewsletterForm-module___4_Mja__blok-subtitle",
  "blok-title": "NewsletterForm-module___4_Mja__blok-title",
  "error": "NewsletterForm-module___4_Mja__error",
  "hide": "NewsletterForm-module___4_Mja__hide",
  "message": "NewsletterForm-module___4_Mja__message",
  "newsletter": "NewsletterForm-module___4_Mja__newsletter",
  "newsletter__input": "NewsletterForm-module___4_Mja__newsletter__input",
  "sr-only": "NewsletterForm-module___4_Mja__sr-only",
  "submit__button": "NewsletterForm-module___4_Mja__submit__button",
  "success": "NewsletterForm-module___4_Mja__success",
});
